import { p as getNodeAttrs } from '../../selectors-f64b5778.js';
import '../../typeof-92b42de1.js';
import '../../slicedToArray-26803f33.js';
import '../../unsupportedIterableToArray-577176bf.js';
import '../../toConsumableArray-2a2700d9.js';
import '../../defineProperty-18999f8e.js';
import '../../configs/index.js';

function getNodeGeometryMetrics(node) {
  var _getNodeAttrs = getNodeAttrs(node),
      x = _getNodeAttrs.x,
      y = _getNodeAttrs.y,
      width = _getNodeAttrs.width,
      height = _getNodeAttrs.height,
      scaleX = _getNodeAttrs.scaleX,
      scaleY = _getNodeAttrs.scaleY,
      _getNodeAttrs$rotatio = _getNodeAttrs.rotation,
      rotation = _getNodeAttrs$rotatio === void 0 ? 0 : _getNodeAttrs$rotatio;

  return {
    x: x,
    y: y,
    width: width,
    height: height,
    scaleX: scaleX,
    scaleY: scaleY,
    rotation: rotation
  };
}

export { getNodeGeometryMetrics as default };
